type PublicConstructor<T> = new (...args: any[]) => T;

abstract class Singleton {
  private static _instance: any;

  protected constructor() {
    if ((this.constructor as typeof Singleton)._instance) {
      throw new Error("Cannot create multiple instances; use getInstance()");
    }
  }

  static getInstance<T extends Singleton>(this: new (...args: any[]) => T): T {
    if (!(this as any)._instance) {
      throw new Error("Singleton has not been initialized yet!");
    }

    return (this as any)._instance;
  }

  static init<T extends Singleton>(
    this: PublicConstructor<T>,
    ...args: ConstructorParameters<PublicConstructor<T>>
  ): T {
    if (!(this as any)._instance) {
      (this as any)._instance = new this(...args);
    }

    return (this as any)._instance;
  }

  /**
   * NOTE: Only use for tests
   */
  static resetInstance() {
    (this as any)._instance = null;
  }
}

export default Singleton;
